import { partnerSupplier } from '@/utils/environment';
import { Platform, StyleSheet } from 'react-native';
import {
  StackNavigationOptions,
  TransitionPresets,
} from '@react-navigation/stack';
import { useMemo } from 'react';

export const GESTURE_RESPONSE_DISTANCE = 50;

export const useDefaultStackScreenOptions = () => {
  return useMemo(
    (): StackNavigationOptions => ({
      animationEnabled: Platform.OS !== 'web',
      // without this, the app thinks everything is in view and will not scroll
      // https://github.com/react-navigation/react-navigation/issues/6165#issue-478174208
      cardStyle: styles.cardStyle,
      gestureResponseDistance: GESTURE_RESPONSE_DISTANCE,
      headerShown: false,
      title: partnerSupplier.fullName,
      ...Platform.select({
        // Always use Android 10 Activity transitions to fix animation problems
        // when using other transition presets
        android: TransitionPresets.ScaleFromCenterAndroid,
        default: TransitionPresets.DefaultTransition,
      }),
    }),
    [],
  );
};

const styles = StyleSheet.create({
  cardStyle: {
    flex: 1,
  },
});
